<template>
  <v-card
    v-if="ticket.status && selectedTicket.status"
    class="ticket max-shadow"
  >
    <v-card-title>
      <div class="title-2">
        Help
      </div>
      <v-spacer />
      <v-btn
        color="primary"
        flat
        @click="changeTicketStatus"
      >
        {{ statusBtnTxt }}
      </v-btn>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-container
        grid-list-md
        class="pa-0"
      >
        <v-layout
          column
          wrap
        >
          <v-flex>
            <v-layout
              row
              wrap
            >
              <v-layout
                row
                wrap
                align-center
                justify-space-around
              >
                <div class="px-2">
                  <avatar
                    :text="createdBy.name"
                    :size="38"
                    :src="createdBy.photo"
                  />
                </div>
                <v-layout
                  column
                  wrap
                  class="px-2"
                >
                  <div class="caption">
                    Created By:
                  </div>
                  <div class="subheading font-weight-medium">
                    {{ createdBy.name }}
                  </div>
                </v-layout>
              </v-layout>
              <div class="pr-4">
                <span :class="getStatusColor(selectedTicket.status)">{{ selectedTicket.status }}</span>
              </div>
            </v-layout>
          </v-flex>
          <v-flex class="py-4">
            <v-layout
              row
              wrap
              align-center
              justify-space-between
            >
              <div class="subheading">
                {{ selectedTicket.title }}
              </div>
              <span>{{ formatTime(selectedTicket.createdAt) }}</span>
            </v-layout>
            <v-layout
              row
              wrap
              align-center
              justify-space-between
            >
              <div class="caption">
                {{ selectedTicket.description }}
              </div>
              <div
                v-if="duration"
                class="caption"
              >
                TAT : {{ duration }}
              </div>
            </v-layout>
          </v-flex>
          <v-flex>
            <v-layout
              row
              wrap
              class="pb-2"
            >
              <v-layout
                row
                wrap
                align-center
                justify-space-around
              >
                <div class="px-2">
                  <avatar
                    :text="assignedTo.name"
                    :size="38"
                    :src="assignedTo.photo"
                  />
                </div>
                <v-layout
                  column
                  wrap
                  class="px-2"
                >
                  <div class="caption">
                    Assigned To:
                  </div>
                  <div class="subheading font-weight-medium">
                    {{ assignedTo.name }}
                  </div>
                </v-layout>
              </v-layout>
            </v-layout>
          </v-flex>
          <v-container
            grid-list-sm
            fluid
            class="pa-1"
          >
            <v-layout
              row
              wrap
            >
              <template v-for="(media, index) in selectedTicket.media">
                <v-flex 
                  :key="index"            
                  xs12
                >
                  <v-img
                    v-if="media.type === 'image'"
                    style="border-radius: 6px"
                    :aspect-ratio="1.3"
                    :src="media.url"
                  />
                </v-flex>
              </template>
            </v-layout>
          </v-container>
          <comments 
            :ticket-id="selectedTicket.id"
          />
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import Avatar from '@/components/common/Avatar';
import Comments from './Comments';
import * as moment from 'moment';
import _get from 'lodash/get';
import { firestore } from '@/firebase';
export default {
  components: {
    avatar: Avatar,
    comments: Comments
  },
  props: {
    ticket: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      selectedTicket: {}
    };
  },
  computed: {
    statusBtnTxt() {
      return this.selectedTicket.status === 'closed' ? 'Reopen' : 'close';
    },
    createdBy() {
      return _get(this.selectedTicket, 'createdBy');
    },
    assignedTo() {
      return _get(this.selectedTicket, 'assignedTo');
    },
    duration() {
      const { createdAt } = this.selectedTicket;
      const { closedAt } = this.selectedTicket;
      if (!closedAt) return null;
      const createdDate = createdAt.toDate();
      const closedDate = closedAt.toDate();
      return moment(closedDate).from(moment(createdDate), true);
    },
    selectedTicketRef() {
      return this.role === 'admin'
        ? firestore
            .doc(`helpDesk/${this.cid}`)
            .collection('tickets')
            .doc(this.selectedTicket.id)
        : firestore
            .doc('helpDesk/buildingSupport')
            .collection('tickets')
            .doc(this.selectedTicket.id);
    }
  },
  watch: {
    ticket: {
      handler(val) {
        // if (!val || !val.createdBy) return;
        this.selectedTicket = val;
      },
      immediate: true
    }
  },
  methods: {
    formatTime(timestamp) {
      const date = timestamp.toDate();
      const today = moment().startOf('day');
      return moment(date).isAfter(today)
        ? moment(date).fromNow()
        : moment(date).calendar(today, {
            lastWeek: 'D MMM [at] hh:mm A',
            sameElse: 'D MMM [at] hh:mm A'
          });
    },
    getStatusColor(status) {
      return status === 'closed'
        ? 'red--text subheading'
        : 'green--text subheading';
    },
    changeTicketStatus() {
      const status = this.statusBtnTxt === 'close' ? 'closed' : 'reopened';
      this.selectedTicketRef
        .update({
          status: status
        })
        .then(() => {
          this.selectedTicketRef.get().then(ticket => {
            this.selectedTicket.status = ticket.data().status;
          });
        });
    }
  }
};
</script>
<style scoped>
.ticket {
  height: calc(100vh - var(--toolbar-height)) !important;
  overflow-y: scroll;
}
</style>
